// Ad configuration + AdSense loader.
// Network-agnostic wrapper: when a real AdSense client is set in .env we render live
// AdSense units; otherwise we show clearly-labelled themed house-ad placeholders so the
// slots are visible in the sandbox before real ad IDs/approval exist.

export const ADSENSE_CLIENT = process.env.REACT_APP_ADSENSE_CLIENT || "";
export const SLOT_BANNER = process.env.REACT_APP_AD_SLOT_BANNER || "";
export const SLOT_INTERSTITIAL = process.env.REACT_APP_AD_SLOT_INTERSTITIAL || "";

export const adsLive = !!ADSENSE_CLIENT;

let scriptRequested = false;
export function ensureAdsenseScript() {
  if (!adsLive || scriptRequested || typeof document === "undefined") return;
  scriptRequested = true;
  // Skip if the tag is already present (e.g. added to index.html <head> for verification).
  if (document.querySelector('script[src*="adsbygoogle.js"]')) return;
  const s = document.createElement("script");
  s.async = true;
  s.src = `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${ADSENSE_CLIENT}`;
  s.crossOrigin = "anonymous";
  document.head.appendChild(s);
}

export function pushAd() {
  try { (window.adsbygoogle = window.adsbygoogle || []).push({}); } catch (e) { /* queued */ }
}

// Themed house ads shown in placeholder mode. Rotates so each page load shows a fresh one.
export const HOUSE_ADS = [
  { title: "Bank your credits", body: "Earn passive interest every cycle at the Orbit Bank.", cta: "Open Bank", to: "/app/bank" },
  { title: "Rotating parts stock", body: "New chassis mods restock hourly at the Bazaar.", cta: "Browse Bazaar", to: "/app/bazaar" },
  { title: "Reforge your bot", body: "Swap legs, arms & heads at the Fabrication Depot.", cta: "Open Depot", to: "/app/depot" },
  { title: "Climb the Arena", body: "Battle rivals, settle grudges, top the ladder.", cta: "Enter Arena", to: "/app/arena" },
  { title: "Score in the Arcade", body: "Play minigames to bank quick credits.", cta: "Play Now", to: "/app/arcade" },
];

let houseCounter = 0;
export function nextHouseAd() {
  const ad = HOUSE_ADS[houseCounter % HOUSE_ADS.length];
  houseCounter += 1;
  return ad;
}
